// extracted by mini-css-extract-plugin
export default {"rodape":"Rodape_rodape__-aTFh","rodape__icones":"Rodape_rodape__icones__lT9VQ"};